/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import React from 'react'
import { Section,  getState, fmt, } from '../twd'
import { useBondDetail } from './use-bond-detail'
import { sectionCss, sectionListCss } from './style'

const state = getState('bond_detail.reference_information', {
    show: true
})

export default () => {
    const [showSection, setShowSection_] = React.useState(state.value.show)
    const setShowSection = React.useCallback((m) => {
        state.set({show:m})
        setShowSection_(m)
    }, [])

    const { issue } = useBondDetail()
    let isSp = issue.structuredPrdCdsInd==='Y' && ['C','S'].indexOf(issue.type)>=0
    if (!isSp) return null

    return <React.Fragment>
    <div className="xs-hide vertical-offset-sm"></div>
    <div data-name='bond-detail-original-issuance'
        className="container vertical-offset-sm"
        css={sectionCss}>

        <div className="row vertical-offset-sm"></div>
        <div className="row"><div className="col-xs-12">
            <Section
                title="Reference Asset(s) Information"
                show={showSection}
                setShow={setShowSection}
                cls="small-header"
                arrowSize="large"
            >
            <dl css={sectionListCss}>
            <dt>Initial valuation date</dt>
            <dd>{fmt.mdy(issue.initialValDate)}</dd>

            <dt>Final valuation date</dt>
            <dd>{fmt.mdy(issue.finalValDate) || fmt.empty()}</dd>

            <dt>Principal protection %</dt>
            <dd>{fmt.cpn(issue.principalProtectionAmt)}</dd>

            <dt>Principal protection type</dt>
            <dd>{issue.principalProtectionDesc || fmt.empty()}</dd>

            <dt>Buffer %</dt>
            <dd>{fmt.cpn(issue.buffer)}</dd>

            <dt>Participation type</dt>
            <dd>{issue.participationDesc || fmt.empty()}</dd>

            <dt>Participation rate</dt>
            <dd>{fmt.qty(issue.participationAmt)}</dd>

            <dt>Minimum return (floor)</dt>
            <dd>{fmt.qty(issue.minRedemptionAmt)}</dd>

            <dt>Maxiumum return (cap)</dt>
            <dd>{fmt.qty(issue.maxRedemptionAmt)}</dd>
            </dl>
            </Section>
        </div></div>

        <div className="row vertical-offset-sm"></div>
    </div>

    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/bond-detail/reference-information.js